module.exports = __webpack_public_path__ + "fc6744e0eef1d36d416a35f3de77fc74.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/che camba.png
// module id = 592
// module chunks = 0